<template>
  <div class="container">
    <div class="bgc">
      <img src="https://p3.ssl.qhimg.com/t012e25ea59a720335b.jpg" alt="" />
    </div>
    <div class="guest">
      <div class="guestBox" v-for="(item, index) in allGuestObj" :key="index">
        <h2>{{ item.title }}</h2>
        <ul class="guestBoxList">
          <li class="listItem" v-for="(subItem, subIndex) in item.user_list" :key="subIndex">
            <div class="listItemBox">
              <p class="avatar">
                <img :src="subItem.avatar" alt="嘉宾图片" class="photo" />
              </p>
              <p class="name">{{ subItem.name }}</p>
              <p class="company">
                <span v-for="(i, j) in subItem.title" :key="j">
                  {{ i }}
                  <span v-if="j !== subItem.title.length - 1">,</span>
                </span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="aboutus">
      <div class="bottom-content">
        <div>
          <h1>关于我们</h1>
          <p>
            ISC是亚太地区乃至当今世界规格高、辐射广、影响力深远的全球性安全峰会。自2013年举办首届以来，ISC十年间举办超20场国际峰会，设立超600场分论坛，输出超4500个行业前沿议题，吸引来自中国、美国、俄罗斯、以色列、德国等全球30多个国家的2000余位政要、行业领袖、安全专家深度参与，共话前瞻安全观点和发展趋势。2022年，ISC跃升“国家级”市场活动，举办首个以数字安全为主题的国家A级会议，成为中国网络安全产业的风向标。
          </p>
        </div>
        <div class="middle-content">
          <p>微信：ISC平台</p>
          <p>微博：ISC官方微博</p>
          <p>邮箱：ISC@360.cn</p>
          <p>投诉通道：ISC@360.cn</p>
          <p>
            <a class="link" target="_blank" href="https://isc.360.com/2020/key-words.html"
              >互联网安全大会</a
            >
          </p>
          <p style="margin-top: 10px">
            <a target="_blank" href="https://isc.360.com/2020/disclaimer.html">
              <u>免责声明及投诉指引</u>
            </a>
          </p>
          <p>
            <a target="_blank" href="https://isc.360.com/2020/user-protocol.html">
              <u>《ISC用户服务协议》</u>
            </a>
          </p>
          <p>
            <a target="_blank" href="https://isc.360.com/2020/login/xy.html">
              <u>《ISC隐私协议》</u>
            </a>
          </p>
        </div>
        <!-- <figure>
          <img class="photo" src="https://p1.ssl.qhimg.com/t01a957317e1bf81190.png" alt="" />
          <figcaption>ISC APP下载</figcaption>
          <img
            class="photo"
            style="margin-top: 10px"
            src="https://p1.ssl.qhimg.com/t01c78a9838de8c3c8d.jpg"
            alt=""
          />
          <figcaption>微信公众号</figcaption>
        </figure> -->
      </div>
    </div>
    <Footers />
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { getAllGuest } from '@/api/2023/index.js'
import Footers from '@/components/common/home-footer.vue'

const allGuestObj = ref([]) // 所有嘉宾数据

const getInfo = () => {
  getAllGuest()
    .then((res) => {
      allGuestObj.value = res.data.data.list
    })
    .catch(() => {})
}

onBeforeMount(async () => {
  await getInfo()
})
</script>

<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.container {
  min-width: 1308px;
  .bgc {
    img {
      width: 100%;
    }
  }
  .guest {
    width: 1308px;
    min-height: 800px;
    margin: 50px auto;
    &Box {
      h2 {
        font-weight: 700;
        font-size: 24px;
        color: #000000;
        line-height: 52px;
        margin-left: 49px;
      }
      &List {
        margin-top: 40px;
        display: flex;
        flex-wrap: wrap;
        .listItem {
          list-style: none;
          margin: 0 35px;
          &Box {
            width: 148px;
            height: 270px;
            text-align: center;
            display: inline-block;
            .avatar {
              width: 130px;
              height: 130px;
              padding: 3px 0 0 1px;
              display: inline-block;
              background: url(https://p5.ssl.qhimg.com/t01247583781d87facf.png) no-repeat;
              background-size: 100% 100%;
              overflow: hidden;
              border-radius: 50%;
              .photo {
                width: 124px;
                border-radius: 50%;
              }
            }
            .name {
              font-weight: 700;
              color: #373c57;
              line-height: 22px;
              font-size: 14px;
              margin: 7px 0 8px;
            }
            .company {
              color: #74799a;
              font-size: 12px;
              line-height: 20px;
            }
          }
        }
      }
    }
  }

  .aboutus {
    padding-bottom: 56px;
    .bottom-content {
      width: 100%;
      min-width: 950px;
      height: 368px;
      background: rgba(227, 227, 238, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 40px 0;
      h1 {
        height: 20px;
        font-size: 20px;
        font-weight: 600;
        color: rgba(54, 60, 89, 1);
        line-height: 20px;
        margin-bottom: 16px;
      }
      p {
        text-align: left;
        max-width: 720px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(54, 60, 89, 1);
        line-height: 24px;
      }
      .middle-content {
        height: 234px;
        margin: 0 40px;
        padding-top: 36px;
        p {
          max-width: 720px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(54, 60, 89, 1);
          line-height: 24px;
          a {
            color: rgba(54, 60, 89, 1);
            text-decoration: none;
            u {
              text-decoration: underline;
            }
          }
        }
      }

      figure {
        flex-shrink: 0;
        height: 234px;
        width: 92px;
        padding-top: 19px;
        text-align: center;
        figcaption {
          height: 14px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(54, 60, 89, 1);
          line-height: 14px;
        }
      }
    }

    .photo {
      width: 92px;
    }
  }
}
</style>
